import { Link } from "react-router-dom";
import LiturgicalBanner from "@/components/LiturgicalBanner";
import TopHeader from "@/components/TopHeader";
import Sidebar from "@/components/Sidebar";

export default function AppLayout({ user, children }) {
  return (
    <div className="min-h-screen bg-[#F9F7F2] flex flex-col">
      <LiturgicalBanner />
      <TopHeader user={user} />
      <div className="flex flex-1 min-w-0">
        <Sidebar user={user} />
        <main className="flex-1 min-h-[calc(100vh-56px)] flex flex-col overflow-x-hidden min-w-0">
          <div className="flex-1">
            {children}
          </div>
          {/* Footer */}
          <footer className="border-t border-[#E5E0D5] bg-[#F9F7F2] py-4 px-4 sm:px-6">
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs text-[#6B665E] font-['Nunito']">
              <Link to="/privacy" className="hover:text-[#2D2A26] transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-[#2D2A26] transition-colors">Terms of Service</Link>
              <Link to="/cookies" className="hover:text-[#2D2A26] transition-colors">Cookie Policy</Link>
              <Link to="/community-guidelines" className="hover:text-[#2D2A26] transition-colors">Community Guidelines</Link>
              <Link to="/marketplace-terms" className="hover:text-[#2D2A26] transition-colors">Marketplace Terms</Link>
            </div>
            <p className="text-center text-[10px] text-[#9B958D] font-['Nunito'] mt-2">
              © {new Date().getFullYear()} Parish. All rights reserved.
            </p>
          </footer>
        </main>
      </div>
    </div>
  );
}
